import Index from './Index.vue';
import AuthService from '../../../services/AuthService';

export default {
  path: 'vendedores',
  name: 'vendedor',
  beforeEnter: (to, from, next) => {
    if (AuthService.isAdmin() || AuthService.isOperacional()) return next();

    return next({
      name: 'home',
      params: {
        accessDenied: true,
      },
    });
  },
  component: Index,
};
